import { gql } from '@apollo/client';
const ARCHIVE_ORDER_OPERATOR = gql `
  mutation ArchiveOrderOperator($orderOperatorId: ID!) {
    archiveOrderOperator(orderOperatorId: $orderOperatorId) {
      orderOperator {
        id
        name
        isOrderOperatorRemovable
        canNameBeUpdated
        status
      }
    }
  }
`;
export default ARCHIVE_ORDER_OPERATOR;
